module.exports = __webpack_public_path__ + "static/media/branch-istanbul-mobile.806c9b9a.jpg";